import { Input, Radio, Select } from 'antd';
import React, { useState } from 'react';

const RankingListFilter = ({ onChangeAuthor, authorEmails, onChangeName, onFilterChange }) => {
  const [filterMode, setFilterMode] = useState('filter');

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value;
    setFilterMode(selectedFilter);
    onFilterChange(selectedFilter);
  };

  const authorOptions = authorEmails.map((email) => ({
    label: email,
    value: email,
  }));

  return (
    <>
      <Radio.Group value={filterMode} onChange={handleFilterChange}>
        <Radio.Button value="filter">Filter</Radio.Button>
        <Radio.Button value="search">Search</Radio.Button>
      </Radio.Group>

      {authorEmails.length > 0 && (
        <>
          {filterMode === 'filter' && (
            <Select
              mode="multiple"
              onChange={onChangeAuthor}
              style={{ minWidth: 450, marginLeft: 5, marginBottom: 10 }}
              placeholder="Filter by Author"
              options={authorOptions}
              allowClear
            />
          )}

          {filterMode === 'search' && (
            <Input
              placeholder="Search by Name"
              style={{ width: 450, marginLeft: 5, marginBottom: 10 }}
              allowClear
              onChange={onChangeName}
            />
          )}
        </>
      )}
    </>
  );
};

export default RankingListFilter;
